import { Injectable } from '@angular/core';
import { ITicketTypeCategory } from 'src/app/models/ticket.model';
import { Provider } from '../provider';

@Injectable()
export class TicketTypeCategoryService extends Provider<ITicketTypeCategory> {
  protected url = 'events/ticket-type-categories';
}
